// AUTO-GENERATED by scripts/build-generators.mjs — do not edit by hand.
// Every codepoint here is verified assigned against @unicode/unicode-16.0.0.

export interface FancyStyle {
  id: string;
  name: string;
  category: string;
  keywords: string[];
  map?: Record<string, string>;
  /** Combining-mark codepoint appended after every visible char. */
  combine?: number;
  /** String inserted between characters (aesthetic spacing). */
  joiner?: string;
  /** [prefix, suffix] wrapped around the whole string. */
  wrap?: [string, string];
}

export interface StyleCategory {
  id: string;
  name: string;
  blurb: string;
}

export const STYLE_CATEGORIES: StyleCategory[] = [
  {
    "id": "cursive",
    "name": "Cursive & Script",
    "blurb": "Looping, calligraphic and handwriting styles."
  },
  {
    "id": "bold",
    "name": "Bold & Strong",
    "blurb": "Heavy, high-impact weights that read loud."
  },
  {
    "id": "italic",
    "name": "Italic & Slanted",
    "blurb": "Leaning, elegant slants for emphasis."
  },
  {
    "id": "gothic",
    "name": "Gothic & Blackletter",
    "blurb": "Old-English fraktur and medieval looks."
  },
  {
    "id": "bubble",
    "name": "Bubble & Circled",
    "blurb": "Letters wrapped in circles and bubbles."
  },
  {
    "id": "square",
    "name": "Square & Boxed",
    "blurb": "Boxed, tiled and squared letterforms."
  },
  {
    "id": "outline",
    "name": "Outline & Double-struck",
    "blurb": "Hollow, outlined and blackboard-bold."
  },
  {
    "id": "mono",
    "name": "Monospace & Code",
    "blurb": "Fixed-width, typewriter and terminal vibes."
  },
  {
    "id": "caps",
    "name": "Small Caps & Wide",
    "blurb": "Small capitals and full-width spacing."
  },
  {
    "id": "aesthetic",
    "name": "Aesthetic & Vaporwave",
    "blurb": "Spaced-out, retro and soft aesthetics."
  },
  {
    "id": "tiny",
    "name": "Tiny Text",
    "blurb": "Super-script and sub-script mini letters."
  },
  {
    "id": "strike",
    "name": "Strikethrough & Underline",
    "blurb": "Crossed-out, underlined and slashed."
  },
  {
    "id": "faux",
    "name": "Faux Script",
    "blurb": "Latin styled with Greek / Cyrillic lookalikes."
  },
  {
    "id": "symbols",
    "name": "Symbols & Frames",
    "blurb": "Decorative borders, hearts, stars and sparkles."
  }
];

export const FANCY_STYLES: FancyStyle[] = [
  {
    "id": "script",
    "name": "Script",
    "category": "cursive",
    "keywords": [
      "script",
      "cursive font",
      "calligraphy",
      "fancy cursive text"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    }
  },
  {
    "id": "bold-script",
    "name": "Bold script",
    "category": "cursive",
    "keywords": [
      "bold script",
      "bold cursive",
      "calligraphy bold"
    ],
    "map": {
      "A": "𝓐",
      "B": "𝓑",
      "C": "𝓒",
      "D": "𝓓",
      "E": "𝓔",
      "F": "𝓕",
      "G": "𝓖",
      "H": "𝓗",
      "I": "𝓘",
      "J": "𝓙",
      "K": "𝓚",
      "L": "𝓛",
      "M": "𝓜",
      "N": "𝓝",
      "O": "𝓞",
      "P": "𝓟",
      "Q": "𝓠",
      "R": "𝓡",
      "S": "𝓢",
      "T": "𝓣",
      "U": "𝓤",
      "V": "𝓥",
      "W": "𝓦",
      "X": "𝓧",
      "Y": "𝓨",
      "Z": "𝓩",
      "a": "𝓪",
      "b": "𝓫",
      "c": "𝓬",
      "d": "𝓭",
      "e": "𝓮",
      "f": "𝓯",
      "g": "𝓰",
      "h": "𝓱",
      "i": "𝓲",
      "j": "𝓳",
      "k": "𝓴",
      "l": "𝓵",
      "m": "𝓶",
      "n": "𝓷",
      "o": "𝓸",
      "p": "𝓹",
      "q": "𝓺",
      "r": "𝓻",
      "s": "𝓼",
      "t": "𝓽",
      "u": "𝓾",
      "v": "𝓿",
      "w": "𝔀",
      "x": "𝔁",
      "y": "𝔂",
      "z": "𝔃"
    }
  },
  {
    "id": "italic",
    "name": "Italic",
    "category": "italic",
    "keywords": [
      "italic",
      "slanted text",
      "oblique"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    }
  },
  {
    "id": "bold-italic",
    "name": "Bold italic",
    "category": "italic",
    "keywords": [
      "bold italic",
      "heavy slant"
    ],
    "map": {
      "A": "𝑨",
      "B": "𝑩",
      "C": "𝑪",
      "D": "𝑫",
      "E": "𝑬",
      "F": "𝑭",
      "G": "𝑮",
      "H": "𝑯",
      "I": "𝑰",
      "J": "𝑱",
      "K": "𝑲",
      "L": "𝑳",
      "M": "𝑴",
      "N": "𝑵",
      "O": "𝑶",
      "P": "𝑷",
      "Q": "𝑸",
      "R": "𝑹",
      "S": "𝑺",
      "T": "𝑻",
      "U": "𝑼",
      "V": "𝑽",
      "W": "𝑾",
      "X": "𝑿",
      "Y": "𝒀",
      "Z": "𝒁",
      "a": "𝒂",
      "b": "𝒃",
      "c": "𝒄",
      "d": "𝒅",
      "e": "𝒆",
      "f": "𝒇",
      "g": "𝒈",
      "h": "𝒉",
      "i": "𝒊",
      "j": "𝒋",
      "k": "𝒌",
      "l": "𝒍",
      "m": "𝒎",
      "n": "𝒏",
      "o": "𝒐",
      "p": "𝒑",
      "q": "𝒒",
      "r": "𝒓",
      "s": "𝒔",
      "t": "𝒕",
      "u": "𝒖",
      "v": "𝒗",
      "w": "𝒘",
      "x": "𝒙",
      "y": "𝒚",
      "z": "𝒛"
    }
  },
  {
    "id": "sans-italic",
    "name": "Sans italic",
    "category": "italic",
    "keywords": [
      "sans italic",
      "clean slant"
    ],
    "map": {
      "A": "𝘈",
      "B": "𝘉",
      "C": "𝘊",
      "D": "𝘋",
      "E": "𝘌",
      "F": "𝘍",
      "G": "𝘎",
      "H": "𝘏",
      "I": "𝘐",
      "J": "𝘑",
      "K": "𝘒",
      "L": "𝘓",
      "M": "𝘔",
      "N": "𝘕",
      "O": "𝘖",
      "P": "𝘗",
      "Q": "𝘘",
      "R": "𝘙",
      "S": "𝘚",
      "T": "𝘛",
      "U": "𝘜",
      "V": "𝘝",
      "W": "𝘞",
      "X": "𝘟",
      "Y": "𝘠",
      "Z": "𝘡",
      "a": "𝘢",
      "b": "𝘣",
      "c": "𝘤",
      "d": "𝘥",
      "e": "𝘦",
      "f": "𝘧",
      "g": "𝘨",
      "h": "𝘩",
      "i": "𝘪",
      "j": "𝘫",
      "k": "𝘬",
      "l": "𝘭",
      "m": "𝘮",
      "n": "𝘯",
      "o": "𝘰",
      "p": "𝘱",
      "q": "𝘲",
      "r": "𝘳",
      "s": "𝘴",
      "t": "𝘵",
      "u": "𝘶",
      "v": "𝘷",
      "w": "𝘸",
      "x": "𝘹",
      "y": "𝘺",
      "z": "𝘻"
    }
  },
  {
    "id": "sans-bold-italic",
    "name": "Sans bold italic",
    "category": "italic",
    "keywords": [
      "sans bold italic"
    ],
    "map": {
      "A": "𝘼",
      "B": "𝘽",
      "C": "𝘾",
      "D": "𝘿",
      "E": "𝙀",
      "F": "𝙁",
      "G": "𝙂",
      "H": "𝙃",
      "I": "𝙄",
      "J": "𝙅",
      "K": "𝙆",
      "L": "𝙇",
      "M": "𝙈",
      "N": "𝙉",
      "O": "𝙊",
      "P": "𝙋",
      "Q": "𝙌",
      "R": "𝙍",
      "S": "𝙎",
      "T": "𝙏",
      "U": "𝙐",
      "V": "𝙑",
      "W": "𝙒",
      "X": "𝙓",
      "Y": "𝙔",
      "Z": "𝙕",
      "a": "𝙖",
      "b": "𝙗",
      "c": "𝙘",
      "d": "𝙙",
      "e": "𝙚",
      "f": "𝙛",
      "g": "𝙜",
      "h": "𝙝",
      "i": "𝙞",
      "j": "𝙟",
      "k": "𝙠",
      "l": "𝙡",
      "m": "𝙢",
      "n": "𝙣",
      "o": "𝙤",
      "p": "𝙥",
      "q": "𝙦",
      "r": "𝙧",
      "s": "𝙨",
      "t": "𝙩",
      "u": "𝙪",
      "v": "𝙫",
      "w": "𝙬",
      "x": "𝙭",
      "y": "𝙮",
      "z": "𝙯"
    }
  },
  {
    "id": "bold",
    "name": "Bold",
    "category": "bold",
    "keywords": [
      "bold",
      "strong text",
      "thick font",
      "heavy"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    }
  },
  {
    "id": "sans-bold",
    "name": "Sans bold",
    "category": "bold",
    "keywords": [
      "sans bold",
      "clean bold",
      "instagram bold font"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    }
  },
  {
    "id": "sans",
    "name": "Sans-serif",
    "category": "mono",
    "keywords": [
      "sans serif",
      "clean font",
      "modern"
    ],
    "map": {
      "0": "𝟢",
      "1": "𝟣",
      "2": "𝟤",
      "3": "𝟥",
      "4": "𝟦",
      "5": "𝟧",
      "6": "𝟨",
      "7": "𝟩",
      "8": "𝟪",
      "9": "𝟫",
      "A": "𝖠",
      "B": "𝖡",
      "C": "𝖢",
      "D": "𝖣",
      "E": "𝖤",
      "F": "𝖥",
      "G": "𝖦",
      "H": "𝖧",
      "I": "𝖨",
      "J": "𝖩",
      "K": "𝖪",
      "L": "𝖫",
      "M": "𝖬",
      "N": "𝖭",
      "O": "𝖮",
      "P": "𝖯",
      "Q": "𝖰",
      "R": "𝖱",
      "S": "𝖲",
      "T": "𝖳",
      "U": "𝖴",
      "V": "𝖵",
      "W": "𝖶",
      "X": "𝖷",
      "Y": "𝖸",
      "Z": "𝖹",
      "a": "𝖺",
      "b": "𝖻",
      "c": "𝖼",
      "d": "𝖽",
      "e": "𝖾",
      "f": "𝖿",
      "g": "𝗀",
      "h": "𝗁",
      "i": "𝗂",
      "j": "𝗃",
      "k": "𝗄",
      "l": "𝗅",
      "m": "𝗆",
      "n": "𝗇",
      "o": "𝗈",
      "p": "𝗉",
      "q": "𝗊",
      "r": "𝗋",
      "s": "𝗌",
      "t": "𝗍",
      "u": "𝗎",
      "v": "𝗏",
      "w": "𝗐",
      "x": "𝗑",
      "y": "𝗒",
      "z": "𝗓"
    }
  },
  {
    "id": "fraktur",
    "name": "Fraktur",
    "category": "gothic",
    "keywords": [
      "fraktur",
      "gothic font",
      "old english",
      "blackletter"
    ],
    "map": {
      "A": "𝔄",
      "B": "𝔅",
      "C": "ℭ",
      "D": "𝔇",
      "E": "𝔈",
      "F": "𝔉",
      "G": "𝔊",
      "H": "ℌ",
      "I": "ℑ",
      "J": "𝔍",
      "K": "𝔎",
      "L": "𝔏",
      "M": "𝔐",
      "N": "𝔑",
      "O": "𝔒",
      "P": "𝔓",
      "Q": "𝔔",
      "R": "ℜ",
      "S": "𝔖",
      "T": "𝔗",
      "U": "𝔘",
      "V": "𝔙",
      "W": "𝔚",
      "X": "𝔛",
      "Y": "𝔜",
      "Z": "ℨ",
      "a": "𝔞",
      "b": "𝔟",
      "c": "𝔠",
      "d": "𝔡",
      "e": "𝔢",
      "f": "𝔣",
      "g": "𝔤",
      "h": "𝔥",
      "i": "𝔦",
      "j": "𝔧",
      "k": "𝔨",
      "l": "𝔩",
      "m": "𝔪",
      "n": "𝔫",
      "o": "𝔬",
      "p": "𝔭",
      "q": "𝔮",
      "r": "𝔯",
      "s": "𝔰",
      "t": "𝔱",
      "u": "𝔲",
      "v": "𝔳",
      "w": "𝔴",
      "x": "𝔵",
      "y": "𝔶",
      "z": "𝔷"
    }
  },
  {
    "id": "bold-fraktur",
    "name": "Bold fraktur",
    "category": "gothic",
    "keywords": [
      "bold gothic",
      "old english bold",
      "medieval"
    ],
    "map": {
      "A": "𝕬",
      "B": "𝕭",
      "C": "𝕮",
      "D": "𝕯",
      "E": "𝕰",
      "F": "𝕱",
      "G": "𝕲",
      "H": "𝕳",
      "I": "𝕴",
      "J": "𝕵",
      "K": "𝕶",
      "L": "𝕷",
      "M": "𝕸",
      "N": "𝕹",
      "O": "𝕺",
      "P": "𝕻",
      "Q": "𝕼",
      "R": "𝕽",
      "S": "𝕾",
      "T": "𝕿",
      "U": "𝖀",
      "V": "𝖁",
      "W": "𝖂",
      "X": "𝖃",
      "Y": "𝖄",
      "Z": "𝖅",
      "a": "𝖆",
      "b": "𝖇",
      "c": "𝖈",
      "d": "𝖉",
      "e": "𝖊",
      "f": "𝖋",
      "g": "𝖌",
      "h": "𝖍",
      "i": "𝖎",
      "j": "𝖏",
      "k": "𝖐",
      "l": "𝖑",
      "m": "𝖒",
      "n": "𝖓",
      "o": "𝖔",
      "p": "𝖕",
      "q": "𝖖",
      "r": "𝖗",
      "s": "𝖘",
      "t": "𝖙",
      "u": "𝖚",
      "v": "𝖛",
      "w": "𝖜",
      "x": "𝖝",
      "y": "𝖞",
      "z": "𝖟"
    }
  },
  {
    "id": "double-struck",
    "name": "Double-struck",
    "category": "outline",
    "keywords": [
      "double struck",
      "blackboard bold",
      "outline letters"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    }
  },
  {
    "id": "monospace",
    "name": "Monospace",
    "category": "mono",
    "keywords": [
      "monospace",
      "typewriter",
      "code font",
      "terminal"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    }
  },
  {
    "id": "small-caps",
    "name": "Small caps",
    "category": "caps",
    "keywords": [
      "small caps",
      "small capitals",
      "sᴍᴀʟʟ ᴄᴀᴘs"
    ],
    "map": {
      "a": "ᴀ",
      "A": "ᴀ",
      "b": "ʙ",
      "B": "ʙ",
      "c": "ᴄ",
      "C": "ᴄ",
      "d": "ᴅ",
      "D": "ᴅ",
      "e": "ᴇ",
      "E": "ᴇ",
      "f": "ꜰ",
      "F": "ꜰ",
      "g": "ɢ",
      "G": "ɢ",
      "h": "ʜ",
      "H": "ʜ",
      "i": "ɪ",
      "I": "ɪ",
      "j": "ᴊ",
      "J": "ᴊ",
      "k": "ᴋ",
      "K": "ᴋ",
      "l": "ʟ",
      "L": "ʟ",
      "m": "ᴍ",
      "M": "ᴍ",
      "n": "ɴ",
      "N": "ɴ",
      "o": "ᴏ",
      "O": "ᴏ",
      "p": "ᴘ",
      "P": "ᴘ",
      "q": "ꞯ",
      "Q": "ꞯ",
      "r": "ʀ",
      "R": "ʀ",
      "s": "ꜱ",
      "S": "ꜱ",
      "t": "ᴛ",
      "T": "ᴛ",
      "u": "ᴜ",
      "U": "ᴜ",
      "v": "ᴠ",
      "V": "ᴠ",
      "w": "ᴡ",
      "W": "ᴡ",
      "y": "ʏ",
      "Y": "ʏ",
      "z": "ᴢ",
      "Z": "ᴢ"
    }
  },
  {
    "id": "fullwidth",
    "name": "Full-width",
    "category": "caps",
    "keywords": [
      "fullwidth",
      "vaporwave",
      "ａｅｓｔｈｅｔｉｃ",
      "wide text"
    ],
    "map": {
      "0": "０",
      "1": "１",
      "2": "２",
      "3": "３",
      "4": "４",
      "5": "５",
      "6": "６",
      "7": "７",
      "8": "８",
      "9": "９",
      " ": "　",
      "!": "！",
      "\"": "＂",
      "#": "＃",
      "$": "＄",
      "%": "％",
      "&": "＆",
      "'": "＇",
      "(": "（",
      ")": "）",
      "*": "＊",
      "+": "＋",
      ",": "，",
      "-": "－",
      ".": "．",
      "/": "／",
      ":": "：",
      ";": "；",
      "<": "＜",
      "=": "＝",
      ">": "＞",
      "?": "？",
      "@": "＠",
      "A": "Ａ",
      "B": "Ｂ",
      "C": "Ｃ",
      "D": "Ｄ",
      "E": "Ｅ",
      "F": "Ｆ",
      "G": "Ｇ",
      "H": "Ｈ",
      "I": "Ｉ",
      "J": "Ｊ",
      "K": "Ｋ",
      "L": "Ｌ",
      "M": "Ｍ",
      "N": "Ｎ",
      "O": "Ｏ",
      "P": "Ｐ",
      "Q": "Ｑ",
      "R": "Ｒ",
      "S": "Ｓ",
      "T": "Ｔ",
      "U": "Ｕ",
      "V": "Ｖ",
      "W": "Ｗ",
      "X": "Ｘ",
      "Y": "Ｙ",
      "Z": "Ｚ",
      "[": "［",
      "\\": "＼",
      "]": "］",
      "^": "＾",
      "_": "＿",
      "`": "｀",
      "a": "ａ",
      "b": "ｂ",
      "c": "ｃ",
      "d": "ｄ",
      "e": "ｅ",
      "f": "ｆ",
      "g": "ｇ",
      "h": "ｈ",
      "i": "ｉ",
      "j": "ｊ",
      "k": "ｋ",
      "l": "ｌ",
      "m": "ｍ",
      "n": "ｎ",
      "o": "ｏ",
      "p": "ｐ",
      "q": "ｑ",
      "r": "ｒ",
      "s": "ｓ",
      "t": "ｔ",
      "u": "ｕ",
      "v": "ｖ",
      "w": "ｗ",
      "x": "ｘ",
      "y": "ｙ",
      "z": "ｚ",
      "{": "｛",
      "|": "｜",
      "}": "｝",
      "~": "～"
    }
  },
  {
    "id": "circled",
    "name": "Circled",
    "category": "bubble",
    "keywords": [
      "circled",
      "bubble letters",
      "circle text",
      "ⓒⓘⓡⓒⓛⓔ"
    ],
    "map": {
      "0": "⓪",
      "1": "①",
      "2": "②",
      "3": "③",
      "4": "④",
      "5": "⑤",
      "6": "⑥",
      "7": "⑦",
      "8": "⑧",
      "9": "⑨",
      "a": "ⓐ",
      "b": "ⓑ",
      "c": "ⓒ",
      "d": "ⓓ",
      "e": "ⓔ",
      "f": "ⓕ",
      "g": "ⓖ",
      "h": "ⓗ",
      "i": "ⓘ",
      "j": "ⓙ",
      "k": "ⓚ",
      "l": "ⓛ",
      "m": "ⓜ",
      "n": "ⓝ",
      "o": "ⓞ",
      "p": "ⓟ",
      "q": "ⓠ",
      "r": "ⓡ",
      "s": "ⓢ",
      "t": "ⓣ",
      "u": "ⓤ",
      "v": "ⓥ",
      "w": "ⓦ",
      "x": "ⓧ",
      "y": "ⓨ",
      "z": "ⓩ",
      "A": "Ⓐ",
      "B": "Ⓑ",
      "C": "Ⓒ",
      "D": "Ⓓ",
      "E": "Ⓔ",
      "F": "Ⓕ",
      "G": "Ⓖ",
      "H": "Ⓗ",
      "I": "Ⓘ",
      "J": "Ⓙ",
      "K": "Ⓚ",
      "L": "Ⓛ",
      "M": "Ⓜ",
      "N": "Ⓝ",
      "O": "Ⓞ",
      "P": "Ⓟ",
      "Q": "Ⓠ",
      "R": "Ⓡ",
      "S": "Ⓢ",
      "T": "Ⓣ",
      "U": "Ⓤ",
      "V": "Ⓥ",
      "W": "Ⓦ",
      "X": "Ⓧ",
      "Y": "Ⓨ",
      "Z": "Ⓩ"
    }
  },
  {
    "id": "circled-negative",
    "name": "Circled black",
    "category": "bubble",
    "keywords": [
      "black circle letters",
      "negative circled",
      "🅑🅤🅑🅑🅛🅔"
    ],
    "map": {
      "0": "⓿",
      "1": "❶",
      "2": "❷",
      "3": "❸",
      "4": "❹",
      "5": "❺",
      "6": "❻",
      "7": "❼",
      "8": "❽",
      "9": "❾",
      "a": "🅐",
      "b": "🅑",
      "c": "🅒",
      "d": "🅓",
      "e": "🅔",
      "f": "🅕",
      "g": "🅖",
      "h": "🅗",
      "i": "🅘",
      "j": "🅙",
      "k": "🅚",
      "l": "🅛",
      "m": "🅜",
      "n": "🅝",
      "o": "🅞",
      "p": "🅟",
      "q": "🅠",
      "r": "🅡",
      "s": "🅢",
      "t": "🅣",
      "u": "🅤",
      "v": "🅥",
      "w": "🅦",
      "x": "🅧",
      "y": "🅨",
      "z": "🅩",
      "A": "🅐",
      "B": "🅑",
      "C": "🅒",
      "D": "🅓",
      "E": "🅔",
      "F": "🅕",
      "G": "🅖",
      "H": "🅗",
      "I": "🅘",
      "J": "🅙",
      "K": "🅚",
      "L": "🅛",
      "M": "🅜",
      "N": "🅝",
      "O": "🅞",
      "P": "🅟",
      "Q": "🅠",
      "R": "🅡",
      "S": "🅢",
      "T": "🅣",
      "U": "🅤",
      "V": "🅥",
      "W": "🅦",
      "X": "🅧",
      "Y": "🅨",
      "Z": "🅩"
    }
  },
  {
    "id": "squared",
    "name": "Squared",
    "category": "square",
    "keywords": [
      "squared letters",
      "boxed text",
      "🅂🅀🅄🄰🅁🄴"
    ],
    "map": {
      "a": "🄰",
      "b": "🄱",
      "c": "🄲",
      "d": "🄳",
      "e": "🄴",
      "f": "🄵",
      "g": "🄶",
      "h": "🄷",
      "i": "🄸",
      "j": "🄹",
      "k": "🄺",
      "l": "🄻",
      "m": "🄼",
      "n": "🄽",
      "o": "🄾",
      "p": "🄿",
      "q": "🅀",
      "r": "🅁",
      "s": "🅂",
      "t": "🅃",
      "u": "🅄",
      "v": "🅅",
      "w": "🅆",
      "x": "🅇",
      "y": "🅈",
      "z": "🅉",
      "A": "🄰",
      "B": "🄱",
      "C": "🄲",
      "D": "🄳",
      "E": "🄴",
      "F": "🄵",
      "G": "🄶",
      "H": "🄷",
      "I": "🄸",
      "J": "🄹",
      "K": "🄺",
      "L": "🄻",
      "M": "🄼",
      "N": "🄽",
      "O": "🄾",
      "P": "🄿",
      "Q": "🅀",
      "R": "🅁",
      "S": "🅂",
      "T": "🅃",
      "U": "🅄",
      "V": "🅅",
      "W": "🅆",
      "X": "🅇",
      "Y": "🅈",
      "Z": "🅉"
    }
  },
  {
    "id": "squared-negative",
    "name": "Squared black",
    "category": "square",
    "keywords": [
      "black square letters",
      "negative squared",
      "🅽🅴🅶🅰🆃🅸🆅🅴"
    ],
    "map": {
      "a": "🅰",
      "b": "🅱",
      "c": "🅲",
      "d": "🅳",
      "e": "🅴",
      "f": "🅵",
      "g": "🅶",
      "h": "🅷",
      "i": "🅸",
      "j": "🅹",
      "k": "🅺",
      "l": "🅻",
      "m": "🅼",
      "n": "🅽",
      "o": "🅾",
      "p": "🅿",
      "q": "🆀",
      "r": "🆁",
      "s": "🆂",
      "t": "🆃",
      "u": "🆄",
      "v": "🆅",
      "w": "🆆",
      "x": "🆇",
      "y": "🆈",
      "z": "🆉",
      "A": "🅰",
      "B": "🅱",
      "C": "🅲",
      "D": "🅳",
      "E": "🅴",
      "F": "🅵",
      "G": "🅶",
      "H": "🅷",
      "I": "🅸",
      "J": "🅹",
      "K": "🅺",
      "L": "🅻",
      "M": "🅼",
      "N": "🅽",
      "O": "🅾",
      "P": "🅿",
      "Q": "🆀",
      "R": "🆁",
      "S": "🆂",
      "T": "🆃",
      "U": "🆄",
      "V": "🆅",
      "W": "🆆",
      "X": "🆇",
      "Y": "🆈",
      "Z": "🆉"
    }
  },
  {
    "id": "parenthesized",
    "name": "Parenthesized",
    "category": "bubble",
    "keywords": [
      "parenthesized",
      "bracketed letters",
      "⒫⒜⒭⒠⒩"
    ],
    "map": {
      "1": "⑴",
      "2": "⑵",
      "3": "⑶",
      "4": "⑷",
      "5": "⑸",
      "6": "⑹",
      "7": "⑺",
      "8": "⑻",
      "9": "⑼",
      "a": "⒜",
      "b": "⒝",
      "c": "⒞",
      "d": "⒟",
      "e": "⒠",
      "f": "⒡",
      "g": "⒢",
      "h": "⒣",
      "i": "⒤",
      "j": "⒥",
      "k": "⒦",
      "l": "⒧",
      "m": "⒨",
      "n": "⒩",
      "o": "⒪",
      "p": "⒫",
      "q": "⒬",
      "r": "⒭",
      "s": "⒮",
      "t": "⒯",
      "u": "⒰",
      "v": "⒱",
      "w": "⒲",
      "x": "⒳",
      "y": "⒴",
      "z": "⒵",
      "A": "⒜",
      "B": "⒝",
      "C": "⒞",
      "D": "⒟",
      "E": "⒠",
      "F": "⒡",
      "G": "⒢",
      "H": "⒣",
      "I": "⒤",
      "J": "⒥",
      "K": "⒦",
      "L": "⒧",
      "M": "⒨",
      "N": "⒩",
      "O": "⒪",
      "P": "⒫",
      "Q": "⒬",
      "R": "⒭",
      "S": "⒮",
      "T": "⒯",
      "U": "⒰",
      "V": "⒱",
      "W": "⒲",
      "X": "⒳",
      "Y": "⒴",
      "Z": "⒵"
    }
  },
  {
    "id": "regional",
    "name": "Bubble flags",
    "category": "bubble",
    "keywords": [
      "regional indicator",
      "flag letters",
      "🇧🇺🇧🇧🇱🇪"
    ],
    "map": {
      "a": "🇦",
      "b": "🇧",
      "c": "🇨",
      "d": "🇩",
      "e": "🇪",
      "f": "🇫",
      "g": "🇬",
      "h": "🇭",
      "i": "🇮",
      "j": "🇯",
      "k": "🇰",
      "l": "🇱",
      "m": "🇲",
      "n": "🇳",
      "o": "🇴",
      "p": "🇵",
      "q": "🇶",
      "r": "🇷",
      "s": "🇸",
      "t": "🇹",
      "u": "🇺",
      "v": "🇻",
      "w": "🇼",
      "x": "🇽",
      "y": "🇾",
      "z": "🇿",
      "A": "🇦",
      "B": "🇧",
      "C": "🇨",
      "D": "🇩",
      "E": "🇪",
      "F": "🇫",
      "G": "🇬",
      "H": "🇭",
      "I": "🇮",
      "J": "🇯",
      "K": "🇰",
      "L": "🇱",
      "M": "🇲",
      "N": "🇳",
      "O": "🇴",
      "P": "🇵",
      "Q": "🇶",
      "R": "🇷",
      "S": "🇸",
      "T": "🇹",
      "U": "🇺",
      "V": "🇻",
      "W": "🇼",
      "X": "🇽",
      "Y": "🇾",
      "Z": "🇿"
    }
  },
  {
    "id": "superscript",
    "name": "Superscript",
    "category": "tiny",
    "keywords": [
      "superscript",
      "tiny text",
      "small letters",
      "ᵗⁱⁿʸ"
    ],
    "map": {
      "0": "⁰",
      "1": "¹",
      "2": "²",
      "3": "³",
      "4": "⁴",
      "5": "⁵",
      "6": "⁶",
      "7": "⁷",
      "8": "⁸",
      "9": "⁹",
      "a": "ᵃ",
      "b": "ᵇ",
      "c": "ᶜ",
      "d": "ᵈ",
      "e": "ᵉ",
      "f": "ᶠ",
      "g": "ᵍ",
      "h": "ʰ",
      "i": "ⁱ",
      "j": "ʲ",
      "k": "ᵏ",
      "l": "ˡ",
      "m": "ᵐ",
      "n": "ᵑ",
      "o": "ᵒ",
      "p": "ᵖ",
      "r": "ʳ",
      "s": "ˢ",
      "t": "ᵗ",
      "u": "ᵘ",
      "v": "ᵛ",
      "w": "ʷ",
      "x": "ˣ",
      "y": "ʸ",
      "z": "ᶻ",
      "A": "ᴬ",
      "B": "ᴮ",
      "D": "ᴰ",
      "E": "ᴱ",
      "G": "ᴳ",
      "H": "ᴴ",
      "I": "ᴵ",
      "J": "ᴶ",
      "K": "ᴷ",
      "L": "ᴸ",
      "M": "ᴹ",
      "N": "ᴺ",
      "O": "ᴻ",
      "P": "ᴾ",
      "R": "ᴿ",
      "T": "ᵀ",
      "U": "ᵁ",
      "V": "ⱽ",
      "W": "ᵂ",
      "C": "ᶜ",
      "F": "ᶠ",
      "S": "ˢ",
      "X": "ˣ",
      "Y": "ʸ",
      "Z": "ᶻ"
    }
  },
  {
    "id": "subscript",
    "name": "Subscript",
    "category": "tiny",
    "keywords": [
      "subscript",
      "tiny lower text",
      "ₛᵤᵦ"
    ],
    "map": {
      "0": "₀",
      "1": "₁",
      "2": "₂",
      "3": "₃",
      "4": "₄",
      "5": "₅",
      "6": "₆",
      "7": "₇",
      "8": "₈",
      "9": "₉",
      "a": "ₐ",
      "e": "ₑ",
      "h": "ₕ",
      "i": "ᵢ",
      "j": "ⱼ",
      "k": "ₖ",
      "l": "ₗ",
      "m": "ₘ",
      "n": "ₙ",
      "o": "ₒ",
      "p": "ₚ",
      "r": "ᵣ",
      "s": "ₛ",
      "t": "ₜ",
      "u": "ᵤ",
      "v": "ᵥ",
      "x": "ₓ",
      "A": "ₐ",
      "E": "ₑ",
      "H": "ₕ",
      "I": "ᵢ",
      "J": "ⱼ",
      "K": "ₖ",
      "L": "ₗ",
      "M": "ₘ",
      "N": "ₙ",
      "O": "ₒ",
      "P": "ₚ",
      "R": "ᵣ",
      "S": "ₛ",
      "T": "ₜ",
      "U": "ᵤ",
      "V": "ᵥ",
      "X": "ₓ"
    }
  },
  {
    "id": "faux-greek",
    "name": "Greek style",
    "category": "faux",
    "keywords": [
      "greek letters",
      "faux greek",
      "αβγ text",
      "toga"
    ],
    "map": {
      "a": "α",
      "b": "β",
      "c": "ϲ",
      "d": "∂",
      "e": "ε",
      "h": "η",
      "i": "ι",
      "k": "κ",
      "m": "μ",
      "n": "η",
      "o": "σ",
      "p": "ρ",
      "r": "γ",
      "s": "ς",
      "t": "τ",
      "u": "υ",
      "v": "ν",
      "w": "ω",
      "x": "χ",
      "y": "γ",
      "A": "Α",
      "B": "Β",
      "E": "Ε",
      "H": "Η",
      "I": "Ι",
      "K": "Κ",
      "M": "Μ",
      "N": "Ν",
      "O": "Ο",
      "P": "Ρ",
      "T": "Τ",
      "X": "Χ",
      "Y": "Υ",
      "Z": "Ζ"
    }
  },
  {
    "id": "faux-cyrillic",
    "name": "Cyrillic style",
    "category": "faux",
    "keywords": [
      "cyrillic",
      "russian style text",
      "faux cyrillic",
      "ЯՄＳＳＩΛИ"
    ],
    "map": {
      "a": "а",
      "b": "в",
      "c": "с",
      "d": "∂",
      "e": "е",
      "g": "г",
      "h": "н",
      "i": "і",
      "j": "ј",
      "k": "к",
      "l": "ӏ",
      "m": "м",
      "n": "и",
      "o": "о",
      "p": "р",
      "r": "я",
      "s": "ѕ",
      "t": "т",
      "u": "ц",
      "w": "ш",
      "x": "х",
      "y": "у",
      "A": "А",
      "B": "Б",
      "C": "С",
      "E": "Е",
      "H": "Н",
      "K": "К",
      "M": "М",
      "O": "О",
      "P": "Р",
      "R": "я",
      "T": "Т",
      "U": "Ц",
      "W": "Ш",
      "X": "Х",
      "Y": "У"
    }
  },
  {
    "id": "wide-spaced",
    "name": "Wide spaced",
    "category": "aesthetic",
    "keywords": [
      "spaced out text",
      "wide",
      "l e t t e r s",
      "aesthetic"
    ],
    "joiner": " "
  },
  {
    "id": "vaporwave",
    "name": "Vaporwave",
    "category": "aesthetic",
    "keywords": [
      "vaporwave",
      "ａｅｓｔｈｅｔｉｃ",
      "wide spaced fullwidth"
    ],
    "map": {
      "0": "０",
      "1": "１",
      "2": "２",
      "3": "３",
      "4": "４",
      "5": "５",
      "6": "６",
      "7": "７",
      "8": "８",
      "9": "９",
      " ": "　",
      "!": "！",
      "\"": "＂",
      "#": "＃",
      "$": "＄",
      "%": "％",
      "&": "＆",
      "'": "＇",
      "(": "（",
      ")": "）",
      "*": "＊",
      "+": "＋",
      ",": "，",
      "-": "－",
      ".": "．",
      "/": "／",
      ":": "：",
      ";": "；",
      "<": "＜",
      "=": "＝",
      ">": "＞",
      "?": "？",
      "@": "＠",
      "A": "Ａ",
      "B": "Ｂ",
      "C": "Ｃ",
      "D": "Ｄ",
      "E": "Ｅ",
      "F": "Ｆ",
      "G": "Ｇ",
      "H": "Ｈ",
      "I": "Ｉ",
      "J": "Ｊ",
      "K": "Ｋ",
      "L": "Ｌ",
      "M": "Ｍ",
      "N": "Ｎ",
      "O": "Ｏ",
      "P": "Ｐ",
      "Q": "Ｑ",
      "R": "Ｒ",
      "S": "Ｓ",
      "T": "Ｔ",
      "U": "Ｕ",
      "V": "Ｖ",
      "W": "Ｗ",
      "X": "Ｘ",
      "Y": "Ｙ",
      "Z": "Ｚ",
      "[": "［",
      "\\": "＼",
      "]": "］",
      "^": "＾",
      "_": "＿",
      "`": "｀",
      "a": "ａ",
      "b": "ｂ",
      "c": "ｃ",
      "d": "ｄ",
      "e": "ｅ",
      "f": "ｆ",
      "g": "ｇ",
      "h": "ｈ",
      "i": "ｉ",
      "j": "ｊ",
      "k": "ｋ",
      "l": "ｌ",
      "m": "ｍ",
      "n": "ｎ",
      "o": "ｏ",
      "p": "ｐ",
      "q": "ｑ",
      "r": "ｒ",
      "s": "ｓ",
      "t": "ｔ",
      "u": "ｕ",
      "v": "ｖ",
      "w": "ｗ",
      "x": "ｘ",
      "y": "ｙ",
      "z": "ｚ",
      "{": "｛",
      "|": "｜",
      "}": "｝",
      "~": "～"
    },
    "joiner": " "
  },
  {
    "id": "strikethrough",
    "name": "Strikethrough",
    "category": "strike",
    "keywords": [
      "strikethrough",
      "cross out text",
      "s̶t̶r̶i̶k̶e̶"
    ],
    "combine": 822
  },
  {
    "id": "underline",
    "name": "Underline",
    "category": "strike",
    "keywords": [
      "underline text",
      "underlined",
      "u̲n̲d̲e̲r̲"
    ],
    "combine": 818
  },
  {
    "id": "double-underline",
    "name": "Double underline",
    "category": "strike",
    "keywords": [
      "double underline",
      "double line"
    ],
    "combine": 819
  },
  {
    "id": "slash-through",
    "name": "Slash through",
    "category": "strike",
    "keywords": [
      "slashed text",
      "slash through",
      "no entry"
    ],
    "combine": 824
  },
  {
    "id": "overline",
    "name": "Overline",
    "category": "strike",
    "keywords": [
      "overline",
      "top line text"
    ],
    "combine": 773
  },
  {
    "id": "tilde-strike",
    "name": "Tilde strike",
    "category": "strike",
    "keywords": [
      "wavy strike",
      "tilde overlay",
      "squiggly"
    ],
    "combine": 820
  },
  {
    "id": "bold-strikethrough",
    "name": "Bold strikethrough",
    "category": "strike",
    "keywords": [
      "bold strikethrough",
      "strikethrough bold"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    },
    "combine": 822
  },
  {
    "id": "bold-underline",
    "name": "Bold underline",
    "category": "strike",
    "keywords": [
      "bold underline",
      "underline bold"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    },
    "combine": 818
  },
  {
    "id": "bold-double-underline",
    "name": "Bold double underline",
    "category": "strike",
    "keywords": [
      "bold double underline",
      "double underline bold"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    },
    "combine": 819
  },
  {
    "id": "bold-slash-through",
    "name": "Bold slash through",
    "category": "strike",
    "keywords": [
      "bold slash through",
      "slash through bold"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    },
    "combine": 824
  },
  {
    "id": "bold-overline",
    "name": "Bold overline",
    "category": "strike",
    "keywords": [
      "bold overline",
      "overline bold"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    },
    "combine": 773
  },
  {
    "id": "bold-tilde-strike",
    "name": "Bold tilde strike",
    "category": "strike",
    "keywords": [
      "bold tilde strike",
      "tilde strike bold"
    ],
    "map": {
      "0": "𝟎",
      "1": "𝟏",
      "2": "𝟐",
      "3": "𝟑",
      "4": "𝟒",
      "5": "𝟓",
      "6": "𝟔",
      "7": "𝟕",
      "8": "𝟖",
      "9": "𝟗",
      "A": "𝐀",
      "B": "𝐁",
      "C": "𝐂",
      "D": "𝐃",
      "E": "𝐄",
      "F": "𝐅",
      "G": "𝐆",
      "H": "𝐇",
      "I": "𝐈",
      "J": "𝐉",
      "K": "𝐊",
      "L": "𝐋",
      "M": "𝐌",
      "N": "𝐍",
      "O": "𝐎",
      "P": "𝐏",
      "Q": "𝐐",
      "R": "𝐑",
      "S": "𝐒",
      "T": "𝐓",
      "U": "𝐔",
      "V": "𝐕",
      "W": "𝐖",
      "X": "𝐗",
      "Y": "𝐘",
      "Z": "𝐙",
      "a": "𝐚",
      "b": "𝐛",
      "c": "𝐜",
      "d": "𝐝",
      "e": "𝐞",
      "f": "𝐟",
      "g": "𝐠",
      "h": "𝐡",
      "i": "𝐢",
      "j": "𝐣",
      "k": "𝐤",
      "l": "𝐥",
      "m": "𝐦",
      "n": "𝐧",
      "o": "𝐨",
      "p": "𝐩",
      "q": "𝐪",
      "r": "𝐫",
      "s": "𝐬",
      "t": "𝐭",
      "u": "𝐮",
      "v": "𝐯",
      "w": "𝐰",
      "x": "𝐱",
      "y": "𝐲",
      "z": "𝐳"
    },
    "combine": 820
  },
  {
    "id": "italic-strikethrough",
    "name": "Italic strikethrough",
    "category": "strike",
    "keywords": [
      "italic strikethrough",
      "strikethrough italic"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    },
    "combine": 822
  },
  {
    "id": "italic-underline",
    "name": "Italic underline",
    "category": "strike",
    "keywords": [
      "italic underline",
      "underline italic"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    },
    "combine": 818
  },
  {
    "id": "italic-double-underline",
    "name": "Italic double underline",
    "category": "strike",
    "keywords": [
      "italic double underline",
      "double underline italic"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    },
    "combine": 819
  },
  {
    "id": "italic-slash-through",
    "name": "Italic slash through",
    "category": "strike",
    "keywords": [
      "italic slash through",
      "slash through italic"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    },
    "combine": 824
  },
  {
    "id": "italic-overline",
    "name": "Italic overline",
    "category": "strike",
    "keywords": [
      "italic overline",
      "overline italic"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    },
    "combine": 773
  },
  {
    "id": "italic-tilde-strike",
    "name": "Italic tilde strike",
    "category": "strike",
    "keywords": [
      "italic tilde strike",
      "tilde strike italic"
    ],
    "map": {
      "A": "𝐴",
      "B": "𝐵",
      "C": "𝐶",
      "D": "𝐷",
      "E": "𝐸",
      "F": "𝐹",
      "G": "𝐺",
      "H": "𝐻",
      "I": "𝐼",
      "J": "𝐽",
      "K": "𝐾",
      "L": "𝐿",
      "M": "𝑀",
      "N": "𝑁",
      "O": "𝑂",
      "P": "𝑃",
      "Q": "𝑄",
      "R": "𝑅",
      "S": "𝑆",
      "T": "𝑇",
      "U": "𝑈",
      "V": "𝑉",
      "W": "𝑊",
      "X": "𝑋",
      "Y": "𝑌",
      "Z": "𝑍",
      "a": "𝑎",
      "b": "𝑏",
      "c": "𝑐",
      "d": "𝑑",
      "e": "𝑒",
      "f": "𝑓",
      "g": "𝑔",
      "h": "ℎ",
      "i": "𝑖",
      "j": "𝑗",
      "k": "𝑘",
      "l": "𝑙",
      "m": "𝑚",
      "n": "𝑛",
      "o": "𝑜",
      "p": "𝑝",
      "q": "𝑞",
      "r": "𝑟",
      "s": "𝑠",
      "t": "𝑡",
      "u": "𝑢",
      "v": "𝑣",
      "w": "𝑤",
      "x": "𝑥",
      "y": "𝑦",
      "z": "𝑧"
    },
    "combine": 820
  },
  {
    "id": "script-strikethrough",
    "name": "Script strikethrough",
    "category": "strike",
    "keywords": [
      "script strikethrough",
      "strikethrough script"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    },
    "combine": 822
  },
  {
    "id": "script-underline",
    "name": "Script underline",
    "category": "strike",
    "keywords": [
      "script underline",
      "underline script"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    },
    "combine": 818
  },
  {
    "id": "script-double-underline",
    "name": "Script double underline",
    "category": "strike",
    "keywords": [
      "script double underline",
      "double underline script"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    },
    "combine": 819
  },
  {
    "id": "script-slash-through",
    "name": "Script slash through",
    "category": "strike",
    "keywords": [
      "script slash through",
      "slash through script"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    },
    "combine": 824
  },
  {
    "id": "script-overline",
    "name": "Script overline",
    "category": "strike",
    "keywords": [
      "script overline",
      "overline script"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    },
    "combine": 773
  },
  {
    "id": "script-tilde-strike",
    "name": "Script tilde strike",
    "category": "strike",
    "keywords": [
      "script tilde strike",
      "tilde strike script"
    ],
    "map": {
      "A": "𝒜",
      "B": "ℬ",
      "C": "𝒞",
      "D": "𝒟",
      "E": "ℰ",
      "F": "ℱ",
      "G": "𝒢",
      "H": "ℋ",
      "I": "ℐ",
      "J": "𝒥",
      "K": "𝒦",
      "L": "ℒ",
      "M": "ℳ",
      "N": "𝒩",
      "O": "𝒪",
      "P": "𝒫",
      "Q": "𝒬",
      "R": "ℛ",
      "S": "𝒮",
      "T": "𝒯",
      "U": "𝒰",
      "V": "𝒱",
      "W": "𝒲",
      "X": "𝒳",
      "Y": "𝒴",
      "Z": "𝒵",
      "a": "𝒶",
      "b": "𝒷",
      "c": "𝒸",
      "d": "𝒹",
      "e": "ℯ",
      "f": "𝒻",
      "g": "ℊ",
      "h": "𝒽",
      "i": "𝒾",
      "j": "𝒿",
      "k": "𝓀",
      "l": "𝓁",
      "m": "𝓂",
      "n": "𝓃",
      "o": "ℴ",
      "p": "𝓅",
      "q": "𝓆",
      "r": "𝓇",
      "s": "𝓈",
      "t": "𝓉",
      "u": "𝓊",
      "v": "𝓋",
      "w": "𝓌",
      "x": "𝓍",
      "y": "𝓎",
      "z": "𝓏"
    },
    "combine": 820
  },
  {
    "id": "sans-bold-strikethrough",
    "name": "Sans bold strikethrough",
    "category": "strike",
    "keywords": [
      "sans bold strikethrough",
      "strikethrough sans bold"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    },
    "combine": 822
  },
  {
    "id": "sans-bold-underline",
    "name": "Sans bold underline",
    "category": "strike",
    "keywords": [
      "sans bold underline",
      "underline sans bold"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    },
    "combine": 818
  },
  {
    "id": "sans-bold-double-underline",
    "name": "Sans bold double underline",
    "category": "strike",
    "keywords": [
      "sans bold double underline",
      "double underline sans bold"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    },
    "combine": 819
  },
  {
    "id": "sans-bold-slash-through",
    "name": "Sans bold slash through",
    "category": "strike",
    "keywords": [
      "sans bold slash through",
      "slash through sans bold"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    },
    "combine": 824
  },
  {
    "id": "sans-bold-overline",
    "name": "Sans bold overline",
    "category": "strike",
    "keywords": [
      "sans bold overline",
      "overline sans bold"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    },
    "combine": 773
  },
  {
    "id": "sans-bold-tilde-strike",
    "name": "Sans bold tilde strike",
    "category": "strike",
    "keywords": [
      "sans bold tilde strike",
      "tilde strike sans bold"
    ],
    "map": {
      "0": "𝟬",
      "1": "𝟭",
      "2": "𝟮",
      "3": "𝟯",
      "4": "𝟰",
      "5": "𝟱",
      "6": "𝟲",
      "7": "𝟳",
      "8": "𝟴",
      "9": "𝟵",
      "A": "𝗔",
      "B": "𝗕",
      "C": "𝗖",
      "D": "𝗗",
      "E": "𝗘",
      "F": "𝗙",
      "G": "𝗚",
      "H": "𝗛",
      "I": "𝗜",
      "J": "𝗝",
      "K": "𝗞",
      "L": "𝗟",
      "M": "𝗠",
      "N": "𝗡",
      "O": "𝗢",
      "P": "𝗣",
      "Q": "𝗤",
      "R": "𝗥",
      "S": "𝗦",
      "T": "𝗧",
      "U": "𝗨",
      "V": "𝗩",
      "W": "𝗪",
      "X": "𝗫",
      "Y": "𝗬",
      "Z": "𝗭",
      "a": "𝗮",
      "b": "𝗯",
      "c": "𝗰",
      "d": "𝗱",
      "e": "𝗲",
      "f": "𝗳",
      "g": "𝗴",
      "h": "𝗵",
      "i": "𝗶",
      "j": "𝗷",
      "k": "𝗸",
      "l": "𝗹",
      "m": "𝗺",
      "n": "𝗻",
      "o": "𝗼",
      "p": "𝗽",
      "q": "𝗾",
      "r": "𝗿",
      "s": "𝘀",
      "t": "𝘁",
      "u": "𝘂",
      "v": "𝘃",
      "w": "𝘄",
      "x": "𝘅",
      "y": "𝘆",
      "z": "𝘇"
    },
    "combine": 820
  },
  {
    "id": "double-struck-strikethrough",
    "name": "Outline strikethrough",
    "category": "strike",
    "keywords": [
      "outline strikethrough",
      "strikethrough outline"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    },
    "combine": 822
  },
  {
    "id": "double-struck-underline",
    "name": "Outline underline",
    "category": "strike",
    "keywords": [
      "outline underline",
      "underline outline"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    },
    "combine": 818
  },
  {
    "id": "double-struck-double-underline",
    "name": "Outline double underline",
    "category": "strike",
    "keywords": [
      "outline double underline",
      "double underline outline"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    },
    "combine": 819
  },
  {
    "id": "double-struck-slash-through",
    "name": "Outline slash through",
    "category": "strike",
    "keywords": [
      "outline slash through",
      "slash through outline"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    },
    "combine": 824
  },
  {
    "id": "double-struck-overline",
    "name": "Outline overline",
    "category": "strike",
    "keywords": [
      "outline overline",
      "overline outline"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    },
    "combine": 773
  },
  {
    "id": "double-struck-tilde-strike",
    "name": "Outline tilde strike",
    "category": "strike",
    "keywords": [
      "outline tilde strike",
      "tilde strike outline"
    ],
    "map": {
      "0": "𝟘",
      "1": "𝟙",
      "2": "𝟚",
      "3": "𝟛",
      "4": "𝟜",
      "5": "𝟝",
      "6": "𝟞",
      "7": "𝟟",
      "8": "𝟠",
      "9": "𝟡",
      "A": "𝔸",
      "B": "𝔹",
      "C": "ℂ",
      "D": "𝔻",
      "E": "𝔼",
      "F": "𝔽",
      "G": "𝔾",
      "H": "ℍ",
      "I": "𝕀",
      "J": "𝕁",
      "K": "𝕂",
      "L": "𝕃",
      "M": "𝕄",
      "N": "ℕ",
      "O": "𝕆",
      "P": "ℙ",
      "Q": "ℚ",
      "R": "ℝ",
      "S": "𝕊",
      "T": "𝕋",
      "U": "𝕌",
      "V": "𝕍",
      "W": "𝕎",
      "X": "𝕏",
      "Y": "𝕐",
      "Z": "ℤ",
      "a": "𝕒",
      "b": "𝕓",
      "c": "𝕔",
      "d": "𝕕",
      "e": "𝕖",
      "f": "𝕗",
      "g": "𝕘",
      "h": "𝕙",
      "i": "𝕚",
      "j": "𝕛",
      "k": "𝕜",
      "l": "𝕝",
      "m": "𝕞",
      "n": "𝕟",
      "o": "𝕠",
      "p": "𝕡",
      "q": "𝕢",
      "r": "𝕣",
      "s": "𝕤",
      "t": "𝕥",
      "u": "𝕦",
      "v": "𝕧",
      "w": "𝕨",
      "x": "𝕩",
      "y": "𝕪",
      "z": "𝕫"
    },
    "combine": 820
  },
  {
    "id": "monospace-strikethrough",
    "name": "Mono strikethrough",
    "category": "strike",
    "keywords": [
      "mono strikethrough",
      "strikethrough mono"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    },
    "combine": 822
  },
  {
    "id": "monospace-underline",
    "name": "Mono underline",
    "category": "strike",
    "keywords": [
      "mono underline",
      "underline mono"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    },
    "combine": 818
  },
  {
    "id": "monospace-double-underline",
    "name": "Mono double underline",
    "category": "strike",
    "keywords": [
      "mono double underline",
      "double underline mono"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    },
    "combine": 819
  },
  {
    "id": "monospace-slash-through",
    "name": "Mono slash through",
    "category": "strike",
    "keywords": [
      "mono slash through",
      "slash through mono"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    },
    "combine": 824
  },
  {
    "id": "monospace-overline",
    "name": "Mono overline",
    "category": "strike",
    "keywords": [
      "mono overline",
      "overline mono"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    },
    "combine": 773
  },
  {
    "id": "monospace-tilde-strike",
    "name": "Mono tilde strike",
    "category": "strike",
    "keywords": [
      "mono tilde strike",
      "tilde strike mono"
    ],
    "map": {
      "0": "𝟶",
      "1": "𝟷",
      "2": "𝟸",
      "3": "𝟹",
      "4": "𝟺",
      "5": "𝟻",
      "6": "𝟼",
      "7": "𝟽",
      "8": "𝟾",
      "9": "𝟿",
      "A": "𝙰",
      "B": "𝙱",
      "C": "𝙲",
      "D": "𝙳",
      "E": "𝙴",
      "F": "𝙵",
      "G": "𝙶",
      "H": "𝙷",
      "I": "𝙸",
      "J": "𝙹",
      "K": "𝙺",
      "L": "𝙻",
      "M": "𝙼",
      "N": "𝙽",
      "O": "𝙾",
      "P": "𝙿",
      "Q": "𝚀",
      "R": "𝚁",
      "S": "𝚂",
      "T": "𝚃",
      "U": "𝚄",
      "V": "𝚅",
      "W": "𝚆",
      "X": "𝚇",
      "Y": "𝚈",
      "Z": "𝚉",
      "a": "𝚊",
      "b": "𝚋",
      "c": "𝚌",
      "d": "𝚍",
      "e": "𝚎",
      "f": "𝚏",
      "g": "𝚐",
      "h": "𝚑",
      "i": "𝚒",
      "j": "𝚓",
      "k": "𝚔",
      "l": "𝚕",
      "m": "𝚖",
      "n": "𝚗",
      "o": "𝚘",
      "p": "𝚙",
      "q": "𝚚",
      "r": "𝚛",
      "s": "𝚜",
      "t": "𝚝",
      "u": "𝚞",
      "v": "𝚟",
      "w": "𝚠",
      "x": "𝚡",
      "y": "𝚢",
      "z": "𝚣"
    },
    "combine": 820
  },
  {
    "id": "dot-spaced",
    "name": "Dot spaced",
    "category": "aesthetic",
    "keywords": [
      "dot separated",
      "middot text",
      "a·b·c"
    ],
    "joiner": "·"
  },
  {
    "id": "dash-spaced",
    "name": "Dash spaced",
    "category": "aesthetic",
    "keywords": [
      "dash separated",
      "hyphen text"
    ],
    "joiner": "-"
  },
  {
    "id": "star-spaced",
    "name": "Star spaced",
    "category": "aesthetic",
    "keywords": [
      "star separated",
      "sparkle spacing"
    ],
    "joiner": "✦"
  },
  {
    "id": "heart-spaced",
    "name": "Heart spaced",
    "category": "aesthetic",
    "keywords": [
      "heart separated",
      "love spacing"
    ],
    "joiner": "♡"
  },
  {
    "id": "frame-hearts-dot",
    "name": "Hearts dot",
    "category": "symbols",
    "keywords": [
      "hearts dot",
      "hearts dot border",
      "hearts dot text"
    ],
    "wrap": [
      ".•♥•.",
      ".•♥•."
    ]
  },
  {
    "id": "frame-heart-arrow",
    "name": "Heart arrow",
    "category": "symbols",
    "keywords": [
      "heart arrow",
      "heart arrow border",
      "heart arrow text"
    ],
    "wrap": [
      "♥➶",
      "➷♥"
    ]
  },
  {
    "id": "frame-sparkle-dots",
    "name": "Sparkle dots",
    "category": "symbols",
    "keywords": [
      "sparkle dots",
      "sparkle dots border",
      "sparkle dots text"
    ],
    "wrap": [
      "•°¯`••´¯°•",
      "•°¯`••´¯°•"
    ]
  },
  {
    "id": "frame-star-swish",
    "name": "Star swish",
    "category": "symbols",
    "keywords": [
      "star swish",
      "star swish border",
      "star swish text"
    ],
    "wrap": [
      "★彡",
      "彡★"
    ]
  },
  {
    "id": "frame-sparkles",
    "name": "Sparkles",
    "category": "symbols",
    "keywords": [
      "sparkles",
      "sparkles border",
      "sparkles text"
    ],
    "wrap": [
      "✧･ﾟ: ",
      " :･ﾟ✧"
    ]
  },
  {
    "id": "frame-twinkle",
    "name": "Twinkle",
    "category": "symbols",
    "keywords": [
      "twinkle",
      "twinkle border",
      "twinkle text"
    ],
    "wrap": [
      "˚｡⋆｡˚",
      "˚｡⋆｡˚"
    ]
  },
  {
    "id": "frame-soft-cloud",
    "name": "Soft cloud",
    "category": "symbols",
    "keywords": [
      "soft cloud",
      "soft cloud border",
      "soft cloud text"
    ],
    "wrap": [
      "ʚɞ",
      "ʚɞ"
    ]
  },
  {
    "id": "frame-flower-corner",
    "name": "Flower corner",
    "category": "symbols",
    "keywords": [
      "flower corner",
      "flower corner border",
      "flower corner text"
    ],
    "wrap": [
      "✿.｡.:* ",
      " *.:｡.✿"
    ]
  },
  {
    "id": "frame-cherry",
    "name": "Cherry",
    "category": "symbols",
    "keywords": [
      "cherry",
      "cherry border",
      "cherry text"
    ],
    "wrap": [
      "❀✿",
      "✿❀"
    ]
  },
  {
    "id": "frame-royal",
    "name": "Royal",
    "category": "symbols",
    "keywords": [
      "royal",
      "royal border",
      "royal text"
    ],
    "wrap": [
      "꧁༺",
      "༻꧂"
    ]
  },
  {
    "id": "frame-fancy-bracket",
    "name": "Fancy bracket",
    "category": "symbols",
    "keywords": [
      "fancy bracket",
      "fancy bracket border",
      "fancy bracket text"
    ],
    "wrap": [
      "꧁",
      "꧂"
    ]
  },
  {
    "id": "frame-tibetan",
    "name": "Tibetan",
    "category": "symbols",
    "keywords": [
      "tibetan",
      "tibetan border",
      "tibetan text"
    ],
    "wrap": [
      "༺",
      "༻"
    ]
  },
  {
    "id": "frame-corner-bracket",
    "name": "Corner bracket",
    "category": "symbols",
    "keywords": [
      "corner bracket",
      "corner bracket border",
      "corner bracket text"
    ],
    "wrap": [
      "「",
      "」"
    ]
  },
  {
    "id": "frame-white-corner",
    "name": "White corner",
    "category": "symbols",
    "keywords": [
      "white corner",
      "white corner border",
      "white corner text"
    ],
    "wrap": [
      "『",
      "』"
    ]
  },
  {
    "id": "frame-lenticular",
    "name": "Lenticular",
    "category": "symbols",
    "keywords": [
      "lenticular",
      "lenticular border",
      "lenticular text"
    ],
    "wrap": [
      "【",
      "】"
    ]
  },
  {
    "id": "frame-angle-double",
    "name": "Angle double",
    "category": "symbols",
    "keywords": [
      "angle double",
      "angle double border",
      "angle double text"
    ],
    "wrap": [
      "《",
      "》"
    ]
  },
  {
    "id": "frame-tortoise",
    "name": "Tortoise",
    "category": "symbols",
    "keywords": [
      "tortoise",
      "tortoise border",
      "tortoise text"
    ],
    "wrap": [
      "〘",
      "〙"
    ]
  },
  {
    "id": "frame-double-square",
    "name": "Double square",
    "category": "symbols",
    "keywords": [
      "double square",
      "double square border",
      "double square text"
    ],
    "wrap": [
      "⟦",
      "⟧"
    ]
  },
  {
    "id": "frame-wave-bracket",
    "name": "Wave bracket",
    "category": "symbols",
    "keywords": [
      "wave bracket",
      "wave bracket border",
      "wave bracket text"
    ],
    "wrap": [
      "⊰",
      "⊱"
    ]
  },
  {
    "id": "frame-lace",
    "name": "Lace",
    "category": "symbols",
    "keywords": [
      "lace",
      "lace border",
      "lace text"
    ],
    "wrap": [
      "꒰",
      "꒱"
    ]
  },
  {
    "id": "frame-arrow-to",
    "name": "Arrow to",
    "category": "symbols",
    "keywords": [
      "arrow to",
      "arrow to border",
      "arrow to text"
    ],
    "wrap": [
      "╰┈➤ ",
      ""
    ]
  },
  {
    "id": "frame-arrows-in",
    "name": "Arrows in",
    "category": "symbols",
    "keywords": [
      "arrows in",
      "arrows in border",
      "arrows in text"
    ],
    "wrap": [
      "↠ ",
      " ↞"
    ]
  },
  {
    "id": "frame-heavy-arrows",
    "name": "Heavy arrows",
    "category": "symbols",
    "keywords": [
      "heavy arrows",
      "heavy arrows border",
      "heavy arrows text"
    ],
    "wrap": [
      "➳ ",
      " ❥"
    ]
  },
  {
    "id": "frame-fire",
    "name": "Fire",
    "category": "symbols",
    "keywords": [
      "fire",
      "fire border",
      "fire text"
    ],
    "wrap": [
      "🔥",
      "🔥"
    ]
  },
  {
    "id": "frame-crown",
    "name": "Crown",
    "category": "symbols",
    "keywords": [
      "crown",
      "crown border",
      "crown text"
    ],
    "wrap": [
      "♕ ",
      " ♕"
    ]
  },
  {
    "id": "frame-chess-frame",
    "name": "Chess frame",
    "category": "symbols",
    "keywords": [
      "chess frame",
      "chess frame border",
      "chess frame text"
    ],
    "wrap": [
      "♛ ",
      " ♛"
    ]
  },
  {
    "id": "frame-music-frame",
    "name": "Music frame",
    "category": "symbols",
    "keywords": [
      "music frame",
      "music frame border",
      "music frame text"
    ],
    "wrap": [
      "♪♫ ",
      " ♫♪"
    ]
  },
  {
    "id": "frame-peace",
    "name": "Peace",
    "category": "symbols",
    "keywords": [
      "peace",
      "peace border",
      "peace text"
    ],
    "wrap": [
      "☮ ",
      " ☮"
    ]
  },
  {
    "id": "frame-yin-yang",
    "name": "Yin yang",
    "category": "symbols",
    "keywords": [
      "yin yang",
      "yin yang border",
      "yin yang text"
    ],
    "wrap": [
      "☯ ",
      " ☯"
    ]
  },
  {
    "id": "frame-snow",
    "name": "Snow",
    "category": "symbols",
    "keywords": [
      "snow",
      "snow border",
      "snow text"
    ],
    "wrap": [
      "❄ ",
      " ❄"
    ]
  },
  {
    "id": "frame-sun-moon",
    "name": "Sun moon",
    "category": "symbols",
    "keywords": [
      "sun moon",
      "sun moon border",
      "sun moon text"
    ],
    "wrap": [
      "☀ ",
      " ☾"
    ]
  },
  {
    "id": "frame-lightning",
    "name": "Lightning",
    "category": "symbols",
    "keywords": [
      "lightning",
      "lightning border",
      "lightning text"
    ],
    "wrap": [
      "⚡ ",
      " ⚡"
    ]
  },
  {
    "id": "frame-skull",
    "name": "Skull",
    "category": "symbols",
    "keywords": [
      "skull",
      "skull border",
      "skull text"
    ],
    "wrap": [
      "☠ ",
      " ☠"
    ]
  },
  {
    "id": "frame-flower-simple",
    "name": "Flower simple",
    "category": "symbols",
    "keywords": [
      "flower simple",
      "flower simple border",
      "flower simple text"
    ],
    "wrap": [
      "❁ ",
      " ❁"
    ]
  },
  {
    "id": "frame-blossom",
    "name": "Blossom",
    "category": "symbols",
    "keywords": [
      "blossom",
      "blossom border",
      "blossom text"
    ],
    "wrap": [
      "✾ ",
      " ✾"
    ]
  },
  {
    "id": "frame-sparkle-star",
    "name": "Sparkle star",
    "category": "symbols",
    "keywords": [
      "sparkle star",
      "sparkle star border",
      "sparkle star text"
    ],
    "wrap": [
      "✦ ",
      " ✦"
    ]
  },
  {
    "id": "frame-four-star",
    "name": "Four star",
    "category": "symbols",
    "keywords": [
      "four star",
      "four star border",
      "four star text"
    ],
    "wrap": [
      "✯ ",
      " ✯"
    ]
  },
  {
    "id": "frame-heavy-heart",
    "name": "Heavy heart",
    "category": "symbols",
    "keywords": [
      "heavy heart",
      "heavy heart border",
      "heavy heart text"
    ],
    "wrap": [
      "❤ ",
      " ❤"
    ]
  },
  {
    "id": "frame-rotated-heart",
    "name": "Rotated heart",
    "category": "symbols",
    "keywords": [
      "rotated heart",
      "rotated heart border",
      "rotated heart text"
    ],
    "wrap": [
      "❥ ",
      " ❥"
    ]
  },
  {
    "id": "frame-white-heart",
    "name": "White heart",
    "category": "symbols",
    "keywords": [
      "white heart",
      "white heart border",
      "white heart text"
    ],
    "wrap": [
      "♡ ",
      " ♡"
    ]
  },
  {
    "id": "frame-diamond",
    "name": "Diamond",
    "category": "symbols",
    "keywords": [
      "diamond",
      "diamond border",
      "diamond text"
    ],
    "wrap": [
      "◆ ",
      " ◆"
    ]
  },
  {
    "id": "frame-white-diamond",
    "name": "White diamond",
    "category": "symbols",
    "keywords": [
      "white diamond",
      "white diamond border",
      "white diamond text"
    ],
    "wrap": [
      "◇ ",
      " ◇"
    ]
  },
  {
    "id": "frame-bullet-line",
    "name": "Bullet line",
    "category": "symbols",
    "keywords": [
      "bullet line",
      "bullet line border",
      "bullet line text"
    ],
    "wrap": [
      "•·.·´¯`·.·• ",
      " •·.·´¯`·.·•"
    ]
  },
  {
    "id": "frame-dotted",
    "name": "Dotted",
    "category": "symbols",
    "keywords": [
      "dotted",
      "dotted border",
      "dotted text"
    ],
    "wrap": [
      "¸„.-•~¹°",
      "°¹~•-.„¸"
    ]
  },
  {
    "id": "frame-barcode",
    "name": "Barcode",
    "category": "symbols",
    "keywords": [
      "barcode",
      "barcode border",
      "barcode text"
    ],
    "wrap": [
      "▌│█║▌║▌║ ",
      " ║▌║▌║█│▌"
    ]
  },
  {
    "id": "frame-block-fade",
    "name": "Block fade",
    "category": "symbols",
    "keywords": [
      "block fade",
      "block fade border",
      "block fade text"
    ],
    "wrap": [
      "▒▓█ ",
      " █▓▒"
    ]
  },
  {
    "id": "frame-shade",
    "name": "Shade",
    "category": "symbols",
    "keywords": [
      "shade",
      "shade border",
      "shade text"
    ],
    "wrap": [
      "░▒▓ ",
      " ▓▒░"
    ]
  },
  {
    "id": "frame-dna",
    "name": "Dna",
    "category": "symbols",
    "keywords": [
      "dna",
      "dna border",
      "dna text"
    ],
    "wrap": [
      "꧁⊱ ",
      " ⊰꧂"
    ]
  },
  {
    "id": "frame-triangle",
    "name": "Triangle",
    "category": "symbols",
    "keywords": [
      "triangle",
      "triangle border",
      "triangle text"
    ],
    "wrap": [
      "◤ ",
      " ◥"
    ]
  },
  {
    "id": "frame-leaf",
    "name": "Leaf",
    "category": "symbols",
    "keywords": [
      "leaf",
      "leaf border",
      "leaf text"
    ],
    "wrap": [
      "✦•······• ",
      " •······•✦"
    ]
  },
  {
    "id": "frame-candy",
    "name": "Candy",
    "category": "symbols",
    "keywords": [
      "candy",
      "candy border",
      "candy text"
    ],
    "wrap": [
      "❤︎❥ ",
      " ❥❤︎"
    ]
  },
  {
    "id": "frame-star-line",
    "name": "Star line",
    "category": "symbols",
    "keywords": [
      "star line",
      "star line border",
      "star line text"
    ],
    "wrap": [
      "·:*¨༺ ",
      " ༻¨*:·"
    ]
  },
  {
    "id": "frame-wing",
    "name": "Wing",
    "category": "symbols",
    "keywords": [
      "wing",
      "wing border",
      "wing text"
    ],
    "wrap": [
      "ʚ ",
      " ɞ"
    ]
  },
  {
    "id": "frame-dagger",
    "name": "Dagger",
    "category": "symbols",
    "keywords": [
      "dagger",
      "dagger border",
      "dagger text"
    ],
    "wrap": [
      "†",
      "†"
    ]
  },
  {
    "id": "frame-cross-frame",
    "name": "Cross frame",
    "category": "symbols",
    "keywords": [
      "cross frame",
      "cross frame border",
      "cross frame text"
    ],
    "wrap": [
      "✟ ",
      " ✟"
    ]
  },
  {
    "id": "frame-umbrella",
    "name": "Umbrella",
    "category": "symbols",
    "keywords": [
      "umbrella",
      "umbrella border",
      "umbrella text"
    ],
    "wrap": [
      "☂ ",
      " ☂"
    ]
  },
  {
    "id": "frame-anchor",
    "name": "Anchor",
    "category": "symbols",
    "keywords": [
      "anchor",
      "anchor border",
      "anchor text"
    ],
    "wrap": [
      "⚓ ",
      " ⚓"
    ]
  },
  {
    "id": "frame-clover",
    "name": "Clover",
    "category": "symbols",
    "keywords": [
      "clover",
      "clover border",
      "clover text"
    ],
    "wrap": [
      "☘ ",
      " ☘"
    ]
  },
  {
    "id": "frame-scissors",
    "name": "Scissors",
    "category": "symbols",
    "keywords": [
      "scissors",
      "scissors border",
      "scissors text"
    ],
    "wrap": [
      "✂ ",
      " ✂"
    ]
  },
  {
    "id": "frame-pencil",
    "name": "Pencil",
    "category": "symbols",
    "keywords": [
      "pencil",
      "pencil border",
      "pencil text"
    ],
    "wrap": [
      "✎ ",
      " ✎"
    ]
  },
  {
    "id": "frame-telephone",
    "name": "Telephone",
    "category": "symbols",
    "keywords": [
      "telephone",
      "telephone border",
      "telephone text"
    ],
    "wrap": [
      "☎ ",
      " ☎"
    ]
  },
  {
    "id": "frame-airplane",
    "name": "Airplane",
    "category": "symbols",
    "keywords": [
      "airplane",
      "airplane border",
      "airplane text"
    ],
    "wrap": [
      "✈ ",
      " ✈"
    ]
  },
  {
    "id": "frame-checkmark",
    "name": "Checkmark",
    "category": "symbols",
    "keywords": [
      "checkmark",
      "checkmark border",
      "checkmark text"
    ],
    "wrap": [
      "✔ ",
      " ✔"
    ]
  },
  {
    "id": "frame-bullseye",
    "name": "Bullseye",
    "category": "symbols",
    "keywords": [
      "bullseye",
      "bullseye border",
      "bullseye text"
    ],
    "wrap": [
      "◉ ",
      " ◉"
    ]
  },
  {
    "id": "frame-gear",
    "name": "Gear",
    "category": "symbols",
    "keywords": [
      "gear",
      "gear border",
      "gear text"
    ],
    "wrap": [
      "⚙ ",
      " ⚙"
    ]
  },
  {
    "id": "frame-infinity",
    "name": "Infinity",
    "category": "symbols",
    "keywords": [
      "infinity",
      "infinity border",
      "infinity text"
    ],
    "wrap": [
      "∞ ",
      " ∞"
    ]
  },
  {
    "id": "frame-section",
    "name": "Section",
    "category": "symbols",
    "keywords": [
      "section",
      "section border",
      "section text"
    ],
    "wrap": [
      "§ ",
      " §"
    ]
  },
  {
    "id": "frame-floral-heart",
    "name": "Floral heart",
    "category": "symbols",
    "keywords": [
      "floral heart",
      "floral heart border",
      "floral heart text"
    ],
    "wrap": [
      "❦ ",
      " ❦"
    ]
  },
  {
    "id": "frame-rotated-floral",
    "name": "Rotated floral",
    "category": "symbols",
    "keywords": [
      "rotated floral",
      "rotated floral border",
      "rotated floral text"
    ],
    "wrap": [
      "❧ ",
      " ❧"
    ]
  },
  {
    "id": "frame-sun-rays",
    "name": "Sun rays",
    "category": "symbols",
    "keywords": [
      "sun rays",
      "sun rays border",
      "sun rays text"
    ],
    "wrap": [
      "❂ ",
      " ❂"
    ]
  },
  {
    "id": "frame-asterisk-flower",
    "name": "Asterisk flower",
    "category": "symbols",
    "keywords": [
      "asterisk flower",
      "asterisk flower border",
      "asterisk flower text"
    ],
    "wrap": [
      "❉ ",
      " ❉"
    ]
  },
  {
    "id": "frame-tight-trifoliate",
    "name": "Tight trifoliate",
    "category": "symbols",
    "keywords": [
      "tight trifoliate",
      "tight trifoliate border",
      "tight trifoliate text"
    ],
    "wrap": [
      "❀❀ ",
      " ❀❀"
    ]
  },
  {
    "id": "frame-heart-bullet",
    "name": "Heart bullet",
    "category": "symbols",
    "keywords": [
      "heart bullet",
      "heart bullet border",
      "heart bullet text"
    ],
    "wrap": [
      "❣ ",
      " ❣"
    ]
  },
  {
    "id": "frame-sparkle-heavy",
    "name": "Sparkle heavy",
    "category": "symbols",
    "keywords": [
      "sparkle heavy",
      "sparkle heavy border",
      "sparkle heavy text"
    ],
    "wrap": [
      "❇ ",
      " ❇"
    ]
  },
  {
    "id": "frame-snowflake-heavy",
    "name": "Snowflake heavy",
    "category": "symbols",
    "keywords": [
      "snowflake heavy",
      "snowflake heavy border",
      "snowflake heavy text"
    ],
    "wrap": [
      "❅ ",
      " ❅"
    ]
  },
  {
    "id": "frame-star-outline",
    "name": "Star outline",
    "category": "symbols",
    "keywords": [
      "star outline",
      "star outline border",
      "star outline text"
    ],
    "wrap": [
      "☆彡 ",
      " 彡☆"
    ]
  },
  {
    "id": "frame-wave-dash",
    "name": "Wave dash",
    "category": "symbols",
    "keywords": [
      "wave dash",
      "wave dash border",
      "wave dash text"
    ],
    "wrap": [
      "〜 ",
      " 〜"
    ]
  },
  {
    "id": "frame-fish-eye",
    "name": "Fish eye",
    "category": "symbols",
    "keywords": [
      "fish eye",
      "fish eye border",
      "fish eye text"
    ],
    "wrap": [
      "◎ ",
      " ◎"
    ]
  },
  {
    "id": "frame-lozenge",
    "name": "Lozenge",
    "category": "symbols",
    "keywords": [
      "lozenge",
      "lozenge border",
      "lozenge text"
    ],
    "wrap": [
      "❖ ",
      " ❖"
    ]
  },
  {
    "id": "frame-pinwheel",
    "name": "Pinwheel",
    "category": "symbols",
    "keywords": [
      "pinwheel",
      "pinwheel border",
      "pinwheel text"
    ],
    "wrap": [
      "❄❆ ",
      " ❆❄"
    ]
  },
  {
    "id": "frame-middot-frame",
    "name": "Middot frame",
    "category": "symbols",
    "keywords": [
      "middot frame",
      "middot frame border",
      "middot frame text"
    ],
    "wrap": [
      "·•· ",
      " ·•·"
    ]
  },
  {
    "id": "frame-bracket-fancy",
    "name": "Bracket fancy",
    "category": "symbols",
    "keywords": [
      "bracket fancy",
      "bracket fancy border",
      "bracket fancy text"
    ],
    "wrap": [
      "⊹⊱ ",
      " ⊰⊹"
    ]
  },
  {
    "id": "frame-sun-symbol",
    "name": "Sun symbol",
    "category": "symbols",
    "keywords": [
      "sun symbol",
      "sun symbol border",
      "sun symbol text"
    ],
    "wrap": [
      "☼ ",
      " ☼"
    ]
  },
  {
    "id": "frame-comet",
    "name": "Comet",
    "category": "symbols",
    "keywords": [
      "comet",
      "comet border",
      "comet text"
    ],
    "wrap": [
      "☄ ",
      " ☄"
    ]
  },
  {
    "id": "frame-mountain",
    "name": "Mountain",
    "category": "symbols",
    "keywords": [
      "mountain",
      "mountain border",
      "mountain text"
    ],
    "wrap": [
      "⛰ ",
      " ⛰"
    ]
  },
  {
    "id": "frame-star-david",
    "name": "Star david",
    "category": "symbols",
    "keywords": [
      "star david",
      "star david border",
      "star david text"
    ],
    "wrap": [
      "✡ ",
      " ✡"
    ]
  },
  {
    "id": "frame-recycle",
    "name": "Recycle",
    "category": "symbols",
    "keywords": [
      "recycle",
      "recycle border",
      "recycle text"
    ],
    "wrap": [
      "♻ ",
      " ♻"
    ]
  },
  {
    "id": "frame-note-double",
    "name": "Note double",
    "category": "symbols",
    "keywords": [
      "note double",
      "note double border",
      "note double text"
    ],
    "wrap": [
      "♬ ",
      " ♬"
    ]
  },
  {
    "id": "frame-spade",
    "name": "Spade",
    "category": "symbols",
    "keywords": [
      "spade",
      "spade border",
      "spade text"
    ],
    "wrap": [
      "♠ ",
      " ♠"
    ]
  },
  {
    "id": "frame-club",
    "name": "Club",
    "category": "symbols",
    "keywords": [
      "club",
      "club border",
      "club text"
    ],
    "wrap": [
      "♣ ",
      " ♣"
    ]
  },
  {
    "id": "frame-heart-suit",
    "name": "Heart suit",
    "category": "symbols",
    "keywords": [
      "heart suit",
      "heart suit border",
      "heart suit text"
    ],
    "wrap": [
      "♥ ",
      " ♥"
    ]
  },
  {
    "id": "frame-diamond-suit",
    "name": "Diamond suit",
    "category": "symbols",
    "keywords": [
      "diamond suit",
      "diamond suit border",
      "diamond suit text"
    ],
    "wrap": [
      "♦ ",
      " ♦"
    ]
  },
  {
    "id": "frame-scroll-ends",
    "name": "Scroll ends",
    "category": "symbols",
    "keywords": [
      "scroll ends",
      "scroll ends border",
      "scroll ends text"
    ],
    "wrap": [
      "❨ ",
      " ❩"
    ]
  },
  {
    "id": "frame-ornate-paren",
    "name": "Ornate paren",
    "category": "symbols",
    "keywords": [
      "ornate paren",
      "ornate paren border",
      "ornate paren text"
    ],
    "wrap": [
      "❪ ",
      " ❫"
    ]
  },
  {
    "id": "frame-medium-bracket",
    "name": "Medium bracket",
    "category": "symbols",
    "keywords": [
      "medium bracket",
      "medium bracket border",
      "medium bracket text"
    ],
    "wrap": [
      "❲ ",
      " ❳"
    ]
  },
  {
    "id": "frame-curly-fancy",
    "name": "Curly fancy",
    "category": "symbols",
    "keywords": [
      "curly fancy",
      "curly fancy border",
      "curly fancy text"
    ],
    "wrap": [
      "❴ ",
      " ❵"
    ]
  },
  {
    "id": "frame-flower-punc",
    "name": "Flower punc",
    "category": "symbols",
    "keywords": [
      "flower punc",
      "flower punc border",
      "flower punc text"
    ],
    "wrap": [
      "⁕ ",
      " ⁕"
    ]
  },
  {
    "id": "frame-asterism",
    "name": "Asterism",
    "category": "symbols",
    "keywords": [
      "asterism",
      "asterism border",
      "asterism text"
    ],
    "wrap": [
      "⁂ ",
      " ⁂"
    ]
  },
  {
    "id": "frame-reference-mark",
    "name": "Reference mark",
    "category": "symbols",
    "keywords": [
      "reference mark",
      "reference mark border",
      "reference mark text"
    ],
    "wrap": [
      "※ ",
      " ※"
    ]
  }
];

export interface Decorator {
  id: string;
  source: "symbol" | "frame" | "kaomoji" | "decorative";
  left: string;
  right: string;
}

export const DECORATORS: Decorator[] = [
  {
    "id": "symbol-0",
    "source": "symbol",
    "left": "♥",
    "right": "♥"
  },
  {
    "id": "symbol-1",
    "source": "symbol",
    "left": "♡",
    "right": "♡"
  },
  {
    "id": "symbol-2",
    "source": "symbol",
    "left": "❤",
    "right": "❤"
  },
  {
    "id": "symbol-3",
    "source": "symbol",
    "left": "★",
    "right": "★"
  },
  {
    "id": "symbol-4",
    "source": "symbol",
    "left": "☆",
    "right": "☆"
  },
  {
    "id": "symbol-5",
    "source": "symbol",
    "left": "✦",
    "right": "✦"
  },
  {
    "id": "symbol-6",
    "source": "symbol",
    "left": "✧",
    "right": "✧"
  },
  {
    "id": "symbol-7",
    "source": "symbol",
    "left": "✩",
    "right": "✩"
  },
  {
    "id": "symbol-8",
    "source": "symbol",
    "left": "✰",
    "right": "✰"
  },
  {
    "id": "symbol-9",
    "source": "symbol",
    "left": "❀",
    "right": "❀"
  },
  {
    "id": "symbol-10",
    "source": "symbol",
    "left": "✿",
    "right": "✿"
  },
  {
    "id": "symbol-11",
    "source": "symbol",
    "left": "❁",
    "right": "❁"
  },
  {
    "id": "symbol-12",
    "source": "symbol",
    "left": "❃",
    "right": "❃"
  },
  {
    "id": "symbol-13",
    "source": "symbol",
    "left": "❉",
    "right": "❉"
  },
  {
    "id": "symbol-14",
    "source": "symbol",
    "left": "❋",
    "right": "❋"
  },
  {
    "id": "symbol-15",
    "source": "symbol",
    "left": "❄",
    "right": "❄"
  },
  {
    "id": "symbol-16",
    "source": "symbol",
    "left": "❆",
    "right": "❆"
  },
  {
    "id": "symbol-17",
    "source": "symbol",
    "left": "♛",
    "right": "♛"
  },
  {
    "id": "symbol-18",
    "source": "symbol",
    "left": "☀",
    "right": "☀"
  },
  {
    "id": "symbol-19",
    "source": "symbol",
    "left": "☾",
    "right": "☾"
  },
  {
    "id": "symbol-20",
    "source": "symbol",
    "left": "♬",
    "right": "♬"
  },
  {
    "id": "symbol-21",
    "source": "symbol",
    "left": "❥",
    "right": "❥"
  },
  {
    "id": "symbol-22",
    "source": "symbol",
    "left": "⊹",
    "right": "⊹"
  },
  {
    "id": "symbol-23",
    "source": "symbol",
    "left": "⋆",
    "right": "⋆"
  },
  {
    "id": "frame-0",
    "source": "frame",
    "left": "꧁༺",
    "right": "༻꧂"
  },
  {
    "id": "frame-1",
    "source": "frame",
    "left": "「",
    "right": "」"
  },
  {
    "id": "frame-2",
    "source": "frame",
    "left": "『",
    "right": "』"
  },
  {
    "id": "frame-3",
    "source": "frame",
    "left": "【",
    "right": "】"
  },
  {
    "id": "frame-4",
    "source": "frame",
    "left": "《",
    "right": "》"
  },
  {
    "id": "frame-5",
    "source": "frame",
    "left": "〘",
    "right": "〙"
  },
  {
    "id": "frame-6",
    "source": "frame",
    "left": "⟦",
    "right": "⟧"
  },
  {
    "id": "frame-7",
    "source": "frame",
    "left": "⊰",
    "right": "⊱"
  },
  {
    "id": "frame-8",
    "source": "frame",
    "left": "꒰",
    "right": "꒱"
  },
  {
    "id": "frame-9",
    "source": "frame",
    "left": ".•♥•.",
    "right": ".•♥•."
  },
  {
    "id": "frame-10",
    "source": "frame",
    "left": "✧･ﾟ:",
    "right": " :･ﾟ✧"
  },
  {
    "id": "frame-11",
    "source": "frame",
    "left": "˚｡⋆｡˚",
    "right": "˚｡⋆｡˚"
  },
  {
    "id": "frame-12",
    "source": "frame",
    "left": "★彡",
    "right": "彡★"
  },
  {
    "id": "frame-13",
    "source": "frame",
    "left": "☆彡",
    "right": "彡☆"
  },
  {
    "id": "frame-14",
    "source": "frame",
    "left": "ʚ",
    "right": "ɞ"
  },
  {
    "id": "frame-15",
    "source": "frame",
    "left": "꧁",
    "right": "꧂"
  },
  {
    "id": "kaomoji-0",
    "source": "kaomoji",
    "left": "(◕‿◕)",
    "right": "(◕‿◕)"
  },
  {
    "id": "kaomoji-1",
    "source": "kaomoji",
    "left": "(｡◕‿◕｡)",
    "right": "(｡◕‿◕｡)"
  },
  {
    "id": "kaomoji-2",
    "source": "kaomoji",
    "left": "(｡♥‿♥｡)",
    "right": "(｡♥‿♥｡)"
  },
  {
    "id": "kaomoji-3",
    "source": "kaomoji",
    "left": "٩(◕‿◕)۶",
    "right": "٩(◕‿◕)۶"
  },
  {
    "id": "kaomoji-4",
    "source": "kaomoji",
    "left": "ʚ(ˊᗨˋ)ɞ",
    "right": "ʚ(ˊᗨˋ)ɞ"
  },
  {
    "id": "kaomoji-5",
    "source": "kaomoji",
    "left": "♡(◡‿◡)",
    "right": "♡(◡‿◡)"
  },
  {
    "id": "kaomoji-6",
    "source": "kaomoji",
    "left": "(≧◡≦)",
    "right": "(≧◡≦)"
  },
  {
    "id": "kaomoji-7",
    "source": "kaomoji",
    "left": "(◍•ᴗ•◍)",
    "right": "(◍•ᴗ•◍)"
  },
  {
    "id": "kaomoji-8",
    "source": "kaomoji",
    "left": "(✿◠‿◠)",
    "right": "(✿◠‿◠)"
  },
  {
    "id": "kaomoji-9",
    "source": "kaomoji",
    "left": "(ﾉ◕ヮ◕)ﾉ",
    "right": "(ﾉ◕ヮ◕)ﾉ"
  },
  {
    "id": "kaomoji-10",
    "source": "kaomoji",
    "left": "(｡•̀ᴗ-)✧",
    "right": "(｡•̀ᴗ-)✧"
  },
  {
    "id": "kaomoji-11",
    "source": "kaomoji",
    "left": "٩(｡•́‿•̀｡)۶",
    "right": "٩(｡•́‿•̀｡)۶"
  },
  {
    "id": "decorative-0",
    "source": "decorative",
    "left": "˗ˏˋ",
    "right": "ˎˊ˗"
  },
  {
    "id": "decorative-1",
    "source": "decorative",
    "left": "⋆｡°✩",
    "right": "✩°｡⋆"
  },
  {
    "id": "decorative-2",
    "source": "decorative",
    "left": "•°¯`••´¯°•",
    "right": "•°¯`••´¯°•"
  },
  {
    "id": "decorative-3",
    "source": "decorative",
    "left": "·:*¨",
    "right": "¨*:·"
  },
  {
    "id": "decorative-4",
    "source": "decorative",
    "left": "°•.",
    "right": ".•°"
  },
  {
    "id": "decorative-5",
    "source": "decorative",
    "left": "˚｡⋆",
    "right": "⋆｡˚"
  },
  {
    "id": "decorative-6",
    "source": "decorative",
    "left": "✦•······•",
    "right": "•······•✦"
  },
  {
    "id": "decorative-7",
    "source": "decorative",
    "left": "⌒*",
    "right": "*⌒"
  },
  {
    "id": "decorative-8",
    "source": "decorative",
    "left": "⊹₊",
    "right": "₊⊹"
  }
];

export const UPSIDE_DOWN_MAP: Record<string, string> = {
  "0": "0",
  "1": "Ɩ",
  "2": "ᄅ",
  "3": "Ɛ",
  "4": "ㄣ",
  "5": "ϛ",
  "6": "9",
  "7": "ㄥ",
  "8": "8",
  "9": "6",
  "a": "ɐ",
  "b": "q",
  "c": "ɔ",
  "d": "p",
  "e": "ǝ",
  "f": "ɟ",
  "g": "ƃ",
  "h": "ɥ",
  "i": "ᴉ",
  "j": "ɾ",
  "k": "ʞ",
  "l": "ꞁ",
  "m": "ɯ",
  "n": "u",
  "o": "o",
  "p": "d",
  "q": "b",
  "r": "ɹ",
  "s": "s",
  "t": "ʇ",
  "u": "n",
  "v": "ʌ",
  "w": "ʍ",
  "x": "x",
  "y": "ʎ",
  "z": "z",
  "A": "∀",
  "B": "B",
  "C": "Ɔ",
  "D": "D",
  "E": "Ǝ",
  "F": "Ⅎ",
  "G": "⅁",
  "H": "H",
  "I": "I",
  "J": "ſ",
  "K": "K",
  "L": "Ꞁ",
  "M": "W",
  "N": "N",
  "O": "O",
  "P": "d",
  "Q": "O",
  "R": "ᴚ",
  "S": "S",
  "T": "⊥",
  "U": "∩",
  "V": "Λ",
  "W": "M",
  "X": "X",
  "Y": "⅄",
  "Z": "Z",
  ".": "˙",
  ",": "'",
  "?": "¿",
  "!": "¡",
  "'": ",",
  "\"": "„",
  "(": ")",
  ")": "(",
  "[": "]",
  "]": "[",
  "{": "}",
  "}": "{",
  "<": ">",
  ">": "<",
  "&": "⅋",
  "_": "‾",
  ";": "؛"
};

export const COMBINING_MARKS: Record<string, number> = {
  "strikethrough": 822,
  "underline": 818,
  "slash-through": 824
};

export const ZALGO_MARKS: { up: number[]; mid: number[]; down: number[] } = {
  "up": [
    768,
    769,
    770,
    771,
    772,
    773,
    774,
    775,
    776,
    777,
    778,
    779,
    780,
    781,
    782,
    783,
    784,
    785,
    786,
    787,
    788,
    829,
    830,
    831,
    832,
    833,
    834,
    835,
    836,
    838,
    842,
    843,
    844,
    848,
    849,
    850,
    855,
    859,
    867,
    868,
    869,
    870,
    871,
    872,
    873,
    874,
    875,
    876,
    877,
    878,
    879
  ],
  "mid": [
    820,
    821,
    822,
    823,
    824,
    864,
    865,
    837
  ],
  "down": [
    790,
    791,
    792,
    793,
    796,
    797,
    798,
    799,
    800,
    801,
    802,
    803,
    804,
    805,
    806,
    807,
    808,
    809,
    810,
    811,
    812,
    813,
    814,
    815,
    816,
    817,
    818,
    819,
    825,
    826,
    827,
    828,
    839,
    840,
    841,
    845,
    846,
    851,
    852,
    853,
    854,
    857,
    858
  ]
};
